import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { EQUAL_WEIGHTS_TITLE } from '../../../../../../../../../common/model/input/value-sets';
import { getValueSetName } from '../../../../../../../../untidy/redux/selectors';
import { useImpactChartHeights } from '../../context';
import { NetScoreBlockCustom } from './net-score-block/net-score-block-custom';
import { NetScoreBlockEqualWeights } from './net-score-block/net-score-block-equal-weights';

export function NetScores() {
  const { bottomBoxPadding: spacing } = useImpactChartHeights();
  const showCustomValueSet = useSelector(getValueSetName) !== EQUAL_WEIGHTS_TITLE;
  return (
    <Root style={{ paddingTop: spacing, paddingBottom: spacing }}>
      <NetScoreBlockEqualWeights />
      {showCustomValueSet && (
        <div style={{ marginTop: spacing }}>
          <NetScoreBlockCustom />
        </div>
      )}
    </Root>
  );
}

const Root = styled.div`
  width: 100%;
`;
